// src/components/Homepage.jsx
import React from 'react';
import './Homepage.css';
import riceBag1 from '../assets/Links/Rice_Bags_Group_1.png';
import riceBag2 from '../assets/Links/Rice_Bags_Group_2.png';
import riceBag3 from '../assets/Links/Rice_Bags_Group_3.png';
import butlerLogo from '../assets/Links/Butler_Logo.png';
import shrivelLogo from '../assets/Links/Shrivel_icon.svg';
import productLine from '../assets/Links/Product_Line.png';
import product1 from '../assets/Links/Rice_Bags_1.png';
import product2 from '../assets/Links/Rice_Bags_2.png';
import product3 from '../assets/Links/Rice_Bags_3.png';
import Footer from '../components/Footer';

const Homepage = () => {
  return (
    <div className="homepage-wrapper">
      <section className="rice-bags">
        <div className="rice-bag1">
            <h3>Kolam Rice</h3>
            <img src={riceBag1} alt="Rice Bag 1" />
            </div>
        <div className="rice-bag2"> 
             <h3>Nei Kichdi Rice</h3>
            <img src={riceBag2} alt="Rice Bag 2" />
            </div>
        <div className="rice-bag3">
            <h3>Rajabogam Rice</h3>
            <img src={riceBag3} alt="Rice Bag 3" />
            </div>
      </section>

      <section className="butler-logo">
        <div className="mill-logo-container">
          <img src={shrivelLogo} alt="Shrivel Logo" />
        </div>
        <div className="butler-logo-container">
          <img src={butlerLogo} alt="Butler Logo" />
        </div>
      </section>
        <section className="our-products">
            <div className="products-text">
                <h2>OUR PRODUCTS</h2>
                <img src={productLine} alt="Product Line" />
                </div>
                <div className="product1">
                    <div className="product1-img">
                        <img src={product1} alt="Product 1" />
                        </div>
                    <div className="product1-text">
                        <h2>Mr. Butler</h2>
                        <h3>Special Rajabogam</h3>
                        <h4>Premium-Aged Rice | Traditional Taste | Mother's Choice</h4>
                        <p>Step into tradition with <strong>Mr. Butler’s Special Rajabogam Rice</strong> — an expertly aged rice that brings home the authentic flavor of South Indian cooking. Naturally matured for enhanced aroma and fluffiness, this rice is the go-to choice for mothers who never compromise on quality.</p>
                        <p>Specially selected and aged under controlled conditions, Rajabogam Old Rice gives you the perfect texture for biryanis, sambars, and traditional festival meals. It absorbs flavors beautifully and remains non-sticky, making every dish rich, flavorful, and full of heritage.</p>
                        </div>
                    </div>
                    <div className="product2">
                
                    <div className="product2-text">
                        <h2>Mr. Butler</h2>
                        <h3>Nei Kitchdi</h3>
                        <h4>Long Grain | Lingering Aroma | Sweet Taste | Premium Quality</h4>
                        <p><strong>Crafted for Comfort. Made for Flavor.</strong></p>
                        <p>Introducing  <strong>Mr. Butler’s Nei Kitchdi Rice</strong> – a specialty rice that turns every simple meal into a soulful experience. With long, slender grains, a gentle lingering aroma, and a naturally sweet finish, this rice is perfect for ghee-rich kichadi, pongal, and other comforting South Indian dishes.</p>
                        <p>Sourced from select farms and milled with precision, this rice absorbs ghee and spices beautifully while maintaining a soft, fluffy texture. It’s everything a traditional kichadi rice should be — light, fragrant, and full of homely goodness.</p>
                        </div>
                        <div className="product2-img">
                        <img src={product3} alt="Product 2" />
                        </div>
                    </div>
            <div className="product3">
                    <div className="product3-img">
                        <img src={product2} alt="Product 3" />
                        </div>
                    <div className="product3-text">
                        <h2>Mr. Butler</h2>
                        <h3>Kolam Ponni Rice</h3>
                        <h4>Medium Grain | Soft Texture | Subtle Aroma | Everyday Premium</h4>
                        <p>Introducing <strong>Mr. Butler Kolam Ponni Rice</strong> – a beloved South Indian staple known for its soft, fluffy texture and gentle aroma. Perfect for everyday meals, this rice blends seamlessly with curries, sambar, rasam, or even a dollop of curd, making every plate feel like home.</p>
                        <p>Carefully cultivated in fertile fields and milled to perfection, our Kolam Ponni Rice is light on the stomach, yet satisfying to the soul. Whether served fresh or as part of a next-day meal, it retains its softness and taste — just the way tradition intended.</p>
                        </div>
                    </div>
            </section>
            <Footer />
            {/* <section className="about-overview">
                <div className="about-text">
                    <h2>ABOUT SHRIVEL</h2>
                    <p><strong>Shrivel Hi-Tech Rice Industries</strong> - Premium rice millers and trusted suppliers from Kangayam, Tamil Nadu – delivering authentic Indian rice with a production capacity of 40 tons per day. Rooted in Tamil soil, milled with precision, and served with pride. From paddy fields to your plate, we bring home the taste of tradition. Each grain reflects our promise – purity, quality, and care in every handful.</p>
                </div>
            </section>
            <section className="contact-info">
                <div className="contact-text">
                    <h2>CONTACT US</h2>
                    <h4>SHRIVEL HITECH RICE INDUSTRIES</h4>
                    <p>331/2, Kovai Road, KadaiYur (Post), Kangayam – 638701, Tirupur District, Tamilnadu, India
Email: srivelmrm@gmail.com
Customer Care No: 04257 247666</p>
</div>
                </section> */}
    </div>
    
  );
};

export default Homepage;